module.exports = __webpack_public_path__ + "static/media/Auto-bid.7be90a60.wav";